import { gql } from '@apollo/client';
import checkPointFieldsFragment from './checkPointFieldsFragment';

const SAVE_CHECK_POINT_DATA = gql`
  mutation SaveCheckPointData($data: CheckPointInput!) {
    saveCheckPoint(data: $data) {
      ...CheckPointFields
    }
  }
  ${checkPointFieldsFragment}
`;

export default SAVE_CHECK_POINT_DATA;
